var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebsite = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#0EA7A2",
  strokeWidth: 0.64,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 11.538A5.538 5.538 0 1 0 6 .46a5.538 5.538 0 0 0 0 11.077Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 11.538c1.39 0 2.517-2.48 2.517-5.539S7.39.461 6 .461 3.482 2.94 3.482 5.999c0 3.06 1.128 5.539 2.518 5.539Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M.462 6.502h11.077"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export { SvgWebsite as ReactComponent };
export default __webpack_public_path__ + "assets/images/website.svg";